import { Breadcrumbs, PlainTooltipComponent } from "@gx1/gx-ui-common";
import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { navigateToUrl } from "single-spa";
import { CustomEvents } from "../../../app.constants";
import { MainNavAppV2Context } from "../../../app-v2.context";

const BreadcrumbsComponent = () => {
  const { t } = useTranslation();
  const [roundTitle, setRoundTitle] = useState("");
  const { initName } = useContext(MainNavAppV2Context);
  const { initiativeId, tab = "" } = useParams();

  useEffect(() => {
    const roundTitleListener = (event: { channel: string, payload: { name: string } | undefined }) => {
      setRoundTitle(event.payload?.name || "");
    };

    let sub: { unsubscribe: () => void };
    void (async () => {
      sub = await window.eventBus.subscribe(CustomEvents.ROUND_TITLE_UPDATED, true, roundTitleListener);
    })();
    return () => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, []);

  const links = useMemo(() => {
    const tabLabelsMapping: Record<string, string> = {
      checklist: t("Checklist"),
      details: t("Evaluation Details"),
      files: t("Documents"),
      product: t("Vendors"),
      products: t("Vendors"),
      requirements: t("Requirements"),
      rounds: t("Evaluation Rounds"),
    };
    const TruncatedCrumb = ({ name }: { name: string }) => {
      const truncatedName = name.length > 25 ? `${name.substring(0, 25)}...` : name;
      return <PlainTooltipComponent deactivate={name.length <= 25} title={name}>{truncatedName}</PlainTooltipComponent>;
    };
    const linksArr = [
      {
        href: `/s/evaluation/${initiativeId}/overview`,
        label:  tab === "overview"
          ? initName || t("Untitled Evaluation")
          : <TruncatedCrumb name={initName || t("Untitled Evaluation")} /> as unknown as string,
        onClick: () => navigateToUrl(`/s/evaluation/${initiativeId}/overview`),
      },
    ];
    if (tab !== "overview") {
      linksArr.push({
        label: tabLabelsMapping[tab],
        href: `/s/evaluation/${initiativeId}/${tab}`,
        onClick: roundTitle
          ? () => navigateToUrl(`/s/evaluation/${initiativeId}/${tab}`)
          : () => { /* empty */ },
      });
      if (roundTitle) {
        linksArr.push({
          label:  <TruncatedCrumb name={roundTitle} /> as unknown as string,
          href: `/s/evaluation/${initiativeId}/${tab}`,
          onClick: () => { /* empty */ },
        });
      }
    }
    return linksArr;
  }, [initName, initiativeId, tab, t, roundTitle]);

  return (
    <Breadcrumbs hideRightBlur links={links} />
  );
};

export default BreadcrumbsComponent;
